<template>
  <li class="headline">
    {{ t('menu.tabs.gameplay') }}
  </li>
  <li @click="grimoire.toggleModal('reference')">
    {{ t('menu.reference') }}
    <em>[R]</em>
  </li>
  <li @click="grimoire.toggleModal('nightOrder')">
    {{ t('menu.nightOrder') }}
    <em>[N]</em>
  </li>
  <li @click="grimoire.toggleModal('notes')">
    {{ t('menu.notes') }}
    <em>[Q]</em>
  </li>
  <li :class="{ disabled: !grimoire.isVoteHistoryAllowed && session.isPlayerOrSpectator }"
    @click="grimoire.toggleModal('voteHistory')">
    {{ t('menu.voteHistory') }}<em>[V]</em>
  </li>
  <li v-if="players.length" @click="playersStore.clearRoles(false)">
    {{ t('menu.clearRoles') }}
    <em><font-awesome-icon icon="trash-alt" class="fa fa-trash-alt" /></em>
  </li>
  <li v-if="grimoire.isTextChatAllowed" @click="chatStore.clearMessages(false)">
    {{ t('menu.clearChat') }}
    <em><font-awesome-icon icon="trash-alt" class="fa fa-trash-alt" /></em>
  </li>
</template>

<script setup lang="ts">
import {
  useChatStore,
  useGrimoireStore,
  useLocaleStore,
  usePlayersStore,
  useSessionStore,
} from "@/stores";
import { computed } from "vue";

const chatStore = useChatStore();
const grimoire = useGrimoireStore();
const locale = useLocaleStore();
const playersStore = usePlayersStore();
const session = useSessionStore();
const t = locale.t;

const players = computed(() => playersStore.players);
</script>

<style lang="scss" src="./Menu.scss" scoped></style>
